import styled, { css } from 'styled-components'

export const HowWeDoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 1170px;

  @media (max-width: 1180px) {
    padding: 0 16px;
  }
  .topics {
    margin-top: 48px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    max-width: 1440px;
    justify-items: center;
    gap: 80px;

    .topic {
      width: 100%;
      max-width: 543px;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .title {
        position: relative;
        z-index: 1;
      }
    }

    @media (max-height: 750px) {
      gap: 60px;
      margin-top: 48px;
    }

    @media (max-width: 700px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 40px;
      margin-top: 40px;

      .topic:first-child > span {
        top: 40%;
      }
    }
  }
`
export type BarProps = {
  color: string
  elementIsVisible: boolean
}

export const Bar = styled.span<BarProps>`
  border: ${(props) => (props.color ? `3px solid ${props.color}` : '')};
  width: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: -1;
  transition: width 0.6s ease-in;

  ${({ elementIsVisible }) =>
    elementIsVisible &&
    css`
      width: 100%;
    `}

  @media (max-width: 700px) {
    bottom: -0.5rem;
    border: ${(props) => (props.color ? `2px solid ${props.color}` : '')};
  }
`
